<template>
  <footer class="footer is-font-3">
    <div class="content-width footer-inner">
      <div class="footer-content ql-editor">
        <slot />
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'partner-footer',
};
</script>

<style lang="scss" scoped src="@/assets/scss/footer/core-footer-partners.scss"/>
<style lang="scss" scoped src="@/assets/scss/footer/footer-partners.scss"/>
